import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & { addButton?: React.ReactNode }
>(({ className, type, addButton, ...props }, ref) => {
  return (
    <div className="relative w-full">
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          addButton && "pr-12",
          className
        )}
        ref={ref}
        {...props}
      />
      {addButton && (
        <div className="absolute right-2 bottom-2">
          {addButton}
        </div>
      )}
    </div>
  )
})
Input.displayName = "Input"

export { Input }
